import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { timeConverter, isDateMoreThanXDaysFromToday, DEADLINE_DAYS } from "../../utils/timeConverter";
import Nav from "../../components/Nav";
import DishPhotoCard from "../dish/components/DishPhotoCard";
import AllergenIcon from "../../components/AllergenIcon";
import { GET_FMB_ITEM_MENUS, GET_FMB_ITEM_USER_SIGNUPS } from "../signups/gql/queries";
import { CREATE_SIGNUP, DELETE_SIGNUP } from "../signups/gql/mutations";
import { GET_ME } from "../user/gql/queries";
import "./FmbItems.css";

const FmbItems = () => {
  const { data: fmbItemMenusData, refetch: refetchFmbItemMenus } = useQuery(GET_FMB_ITEM_MENUS, {
    fetchPolicy: 'network-only'
  });
  const { data: fmbItemUserSignupsData, refetch: refetchFmbItemUserSignups } = useQuery(GET_FMB_ITEM_USER_SIGNUPS, {
    fetchPolicy: 'network-only'
  });

  const [createSignup] = useMutation(CREATE_SIGNUP);
  const [deleteSignup] = useMutation(DELETE_SIGNUP);
  const { data } = useQuery(GET_ME);
  const me = data?.me;

  const fmbItemMenus = fmbItemMenusData?.fmbItemMenus || [];
  const fmbItemUserSignups = fmbItemUserSignupsData?.fmbItemUserSignups || [];

  const availableMenus = fmbItemMenus.filter(menu => {
    return !fmbItemUserSignups.some(signup =>
      signup.menuItem._id === menu._id
    );
  });

  const onAddClick = async (menuItemId) => {
    try {
      await createSignup({
        variables: {
          menuItem: menuItemId,
          user: me.userId,
          size: "Large",
        },
      });

      await refetchFmbItemMenus();
      await refetchFmbItemUserSignups();
      showModal();
    } catch (err) {
      console.error(err);
    }
  };

  const onDeleteClick = async (event) => {
    try {
      await deleteSignup({
        variables: {
          signupId: event.target.id,
        },
      });

      await refetchFmbItemUserSignups();
      await refetchFmbItemMenus();
    } catch (err) {
      console.error(err);
    }
  };

  const showModal = () => {
    const modal = document.querySelector('.modalParent')
    modal.style.visibility = 'visible'
  };

  const closeModal = () => {
    const modal = document.querySelector('.modalParent')
    modal.style.visibility = 'hidden'
  }

  return (
    <>
      <div className="navAndHeader">
        <Nav />
      </div>

      <div className="modalParent">
        <div className="modalSuccessful">
          <h3>Signup Successful!</h3>
          <button className='ok' onClick={closeModal}><p>Close</p></button>
        </div>
      </div>

      <div className="mainContainer">
        <h1>Items</h1>
        <div className="signupsContainer" id="fmbItemMenusContainer">
          {availableMenus.length === 0 ? (
            <div className="fmbItems-grid-center">
              <p className="errMsg fmbItems-error-message">
                No items available
              </p>
            </div>
          ) : (
            availableMenus.map((menu) => (
              <div key={menu._id} className="signup">
                <div className="signupsRow" key={menu._id}>
                  <div className="openSignupInfo">
                    <div className="dishNameWithAllergens">
                      <p>{menu.dish?.dishName}</p>
                      <AllergenIcon
                        allergens={menu.dish?.allergens}
                        calories={menu.dish?.calories}
                      />
                    </div>
                    <p>{timeConverter(menu.menuDate)}</p>
                  </div>
                  <div className="addButtonAndPhoto">
                    <div className="addButton">
                      <p className="addSignupPlus" onClick={() => onAddClick(menu._id)}>+</p>
                    </div>
                    <div className="dishPhotoContainer">
                      <DishPhotoCard image={menu.dish?.dishPhoto} radius={"15"} border={"3px_solid_rgb:6B802A"} height={"130"} width={"130"} />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <h1>Signups</h1>

        <div className="signupsContainer">
          {(() => {
            const sortedSignups = [...fmbItemUserSignups]
              .sort((a, b) => a.menuItem?.menuDate - b.menuItem?.menuDate);
            return sortedSignups.length === 0 ? (
              <div className="fmbItems-grid-center">
                <p className="errMsg fmbItems-error-message">
                  No signups
                </p>
              </div>
            ) : (
              sortedSignups.map((signup) => (
                <div key={signup._id} className="signup">
                  <div className="signupsRow">
                    <div className="openSignupInfo">
                      <div className="dishNameWithAllergens">
                        <p>{signup.menuItem?.dish?.dishName}</p>
                        <AllergenIcon
                          allergens={signup.menuItem?.dish?.allergens}
                          calories={signup.menuItem?.dish?.calories}
                        />
                      </div>
                      <p>{timeConverter(signup.menuItem.menuDate)}</p>
                    </div>
                    <div className="addButtonAndPhoto">
                      {isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="cancelButton">
                          <p id={signup._id} onClick={onDeleteClick} className="cancelButtonText">Remove</p>
                        </div>
                      )}
                      {!isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="cancelButton fmbItems-disabled-button">
                          <p id={signup._id} className="cancelButtonText">Remove</p>
                        </div>
                      )}
                      <div className="dishPhotoContainer">
                        <DishPhotoCard image={signup.menuItem?.dish?.dishPhoto} radius={"15"} border={"3px_solid_rgb:6B802A"} height={"130"} width={"130"} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            );
          })()}
        </div>
      </div>
    </>
  );
};

export default FmbItems;

